import { render, staticRenderFns } from "./subAdd.vue?vue&type=template&id=5a372465&"
import script from "./subAdd.vue?vue&type=script&lang=js&"
export * from "./subAdd.vue?vue&type=script&lang=js&"
import style0 from "./subAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports